import  { useState } from "react";
import DeliveryManagement from "../userComponent/deliveryManagement"
import StoreManagement from "../userComponent/storeManagement"
import Breadcrumb from "../../../../component/breadcrumb"
import { Box, Typography } from "@mui/material";
import { useSelector } from 'react-redux';
import ProgressBar from "../../../../component/progressBar"


const BCrumb = [
    {
        to: '/app/user-management',
        title: 'User Management',
    },
    {
        title: 'Create User',
    },
];

function CreateUser() {
     const { userType } = useSelector(state => state.counter);
     const [progressValue, setProgressValue] = useState(0);
     const progressHandler = (progress) => {
        setProgressValue(progress)
      }
     
        

    return (
        <div className="px-[24px]">
            <div className="flex justify-between mb-5 ml-7 mr-4">
                <Breadcrumb title="" items={BCrumb} />
                <div className="flex items-center gap-1 mr-[16px]"
                 
                >
                    <Typography>Profile Completion</Typography>
                    <ProgressBar progress = {progressValue}/>
                </div>
            </div>
            {userType === "delivery user" && (
                <DeliveryManagement handleProgress={progressHandler} user={"admin"} mode= {"create"}/>
            )}
            {userType === "business user" && (
                <StoreManagement handleProgress={progressHandler} user={"admin"} mode= {"create"}/>
            )}

        </div>

    );
}

export default CreateUser;
